import { Search } from 'lucide-react';

interface CommandBarFallbackProps {
  message: string;
  query: string;
  onQueryChange: (query: string) => void;
}

const CommandBarFallback = ({ message, query, onQueryChange }: CommandBarFallbackProps) => {
  return (
    <div className="rounded-3xl border border-slate-200 bg-white p-6 shadow-sm">
      <div className="mx-auto max-w-2xl">
        <div className="mb-4 flex items-center gap-3">
          <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-slate-100 text-slate-700">
            <Search className="h-5 w-5" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-slate-900">Universal Command Bar</h2>
            <p className="text-sm text-slate-500">Fallback interface for low-confidence or failed intent resolution.</p>
          </div>
        </div>

        <label className="sr-only" htmlFor="intent-fallback-query">
          Describe what you want to do
        </label>
        <input
          id="intent-fallback-query"
          value={query}
          onChange={(event) => onQueryChange(event.target.value)}
          placeholder="Describe your goal in plain language"
          className="w-full rounded-2xl border border-slate-300 px-4 py-3 text-slate-900 shadow-inner outline-none transition focus:border-blue-500"
        />

        <p className="mt-3 rounded-2xl bg-slate-50 px-4 py-3 text-sm text-slate-600">{message}</p>
      </div>
    </div>
  );
};

export default CommandBarFallback;